import vi from "./vi.svg";
import en from "./en.svg";

const baseUrlCdn = process.env.REACT_APP_BASE_URL_CDN || "https://cdn.smartbadminton.com/";

export const IMAGE = {
  logo: baseUrlCdn.concat("media/logo-smartbadminton.png"),
  logoVi: vi,
  logoEn: en,
}